import { Injectable } from '@angular/core';
import {DatePipe} from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConstantService {
  pattern = /([^\w\s])/g;

  constructor(private datePipe: DatePipe) { }
  readonly ApiUrl: string = environment.appUrl;
    displayUsername: string = "";
    accessKey: string = "";
    isLoggedIn: boolean = false;
    readonly defaultuser:string=environment.defaultuser;
    readonly defaultkey:string=environment.defaultkey;
    prodData:any;
    applicationUrl: string = '';
    urlRights = new BehaviorSubject<any>(false);
    permittedRoute = new BehaviorSubject<boolean>(true);    
    keywordList = new BehaviorSubject<any>([]);

    getPermittedRoute() {
      return this.permittedRoute.asObservable();
    }

    sendPermittedRoute(data: any) {
        this.permittedRoute.next(data);
    }

    GoToMainUrl()
    {
        window.location.href = 'https://www.chemrobotics.com/';
    }

    sendurlRights(data: any) {
        this.urlRights.next(data);
    }
    
    geturlRights() {
      return this.urlRights.asObservable();
    }

    sendKeywordList(data: any) {
      this.keywordList.next(data);
    }

    getKeywordList() {
      return this.keywordList.asObservable();
    }

    getTableFilterCondition(filterdata:any):any{
        let filterconditionsMongo:any = [];
        if(filterdata){
            Object.keys(filterdata).forEach(item=>{
               let columnname=item;
               let filterconditions_temp=[];
               if(Array.isArray(filterdata[item])){
                   let arrayconditions=filterdata[item];
                   arrayconditions.forEach((element:any) => {
                        filterconditions_temp.push({filterconditionvalue:element.value,matchMode: element.matchMode});
                   });                
               }
               else{
                filterconditions_temp.push({filterconditionvalue:filterdata[item].value,matchMode: filterdata[item].matchMode});
               }
               
               filterconditions_temp.forEach(item=>{            
                if(item.filterconditionvalue || item.matchMode === 'empty' || item.matchMode === 'not null'){                    
                    switch (item.matchMode) {
                        case "startsWith":
                           filterconditionsMongo.push({[columnname]: {$regex: `^${item.filterconditionvalue.replace(this.pattern, '\\$&')}`, $options: 'i'}});
                            break;
                        case "endsWith":
                            filterconditionsMongo.push({[columnname]: {$regex: `${item.filterconditionvalue.replace(this.pattern, '\\$&')}$`, $options: 'i'}});
                            break;
                        case "contains":
                            if((item.filterconditionvalue instanceof Date)){
                               item.filterconditionvalue=this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd")
                            }
                            filterconditionsMongo.push({[columnname]: {$regex: `${item.filterconditionvalue.replace(this.pattern, '\\$&')}`, $options: 'i'}});
                            break;
                        case "notContains":
                            filterconditionsMongo.push({[columnname]: { $not: {$regex: `${item.filterconditionvalue.replace(this.pattern, '\\$&')}`, $options: 'i'} }});
                            break;
                        case "equals":
                            filterconditionsMongo.push({[columnname]: {$regex: `^${item.filterconditionvalue.replace(this.pattern, '\\$&')}$`, $options: 'i'}});
                            break;
                        case "notEquals":
                            filterconditionsMongo.push({[columnname]: { $not: {$regex: `^${item.filterconditionvalue.replace(this.pattern, '\\$&')}$`, $options: 'i'}}});
                            break;
                        case "dateAfter":
                            filterconditionsMongo.push({ $expr: { $gte: [
                                { $toDate: `$${columnname}` },
                                { $toDate: this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd") }
                            ]}});
                            break;
                        case "dateBefore":
                            filterconditionsMongo.push({ $expr: { $lte: [
                                { $toDate: `$${columnname}` },
                                { $toDate: this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd") }
                            ]}});
                            break;
                        case "dateIs":
                            filterconditionsMongo.push({ $expr: { $eq: [
                                { $toDate: `$${columnname}` },
                                { $toDate: this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd") }
                            ]}});
                            break;
                        case "dateIsNot":
                            filterconditionsMongo.push({ $expr: { $ne: [
                                { $toDate: `$${columnname}` },
                                { $toDate: this.datePipe.transform(item.filterconditionvalue,"yyyy-MM-dd") }
                            ]}});
                            break;
                        case "empty":
                            filterconditionsMongo.push({ $or: [
                                { [columnname]: '' },
                                { [columnname]: null }
                            ]});
                            break;
                        case "not null":
                            filterconditionsMongo.push({ $and: [
                                { [columnname]: { $ne: '' } },
                                { [columnname]: { $ne: null } }
                            ]});
                            break; 
                        default:
                            break;
                    }
                }
               });
               
            });
        }
        return filterconditionsMongo;
    }
    getAppprivilege(privilege_json: any, appname: string, userid: number) {
        if (privilege_json) {
          let privilegetemp = JSON.parse(privilege_json);
          let priv_app = privilegetemp[`user_${userid}`][appname];
      
          // ✅ Boolean conversions
          priv_app['View'] = priv_app['View'] === "true" || priv_app['View'] === true;
          priv_app['Download'] = priv_app['Download'] === "true" || priv_app['Download'] === true;
          priv_app['GraphDownload'] = priv_app['GraphDownload'] === "true" || priv_app['GraphDownload'] === true;
          priv_app['SplitDownload'] = priv_app['SplitDownload'] === "true" || priv_app['SplitDownload'] === true;
      
          // ✅ Number conversions (force unsigned integer with >>> 0 or parseInt fallback)
          priv_app['Search'] = priv_app['Search'] >>> 0;
          priv_app['DownloadCount'] = priv_app['DownloadCount'] >>> 0;
          priv_app['DailySearchLimit'] = priv_app['DailySearchLimit'] >>> 0;
          priv_app['DailyDownloadLimit'] = priv_app['DailyDownloadLimit'] >>> 0;
          priv_app['InitialSearchCount'] = priv_app['InitialSearchCount'] >>> 0;
          priv_app['InitialDownloadCount'] = priv_app['InitialDownloadCount'] >>> 0;
          priv_app['GraphDownloadCount'] = priv_app['GraphDownloadCount'] ? (priv_app['GraphDownloadCount'] >>> 0) : 0;
          priv_app['PageLimit'] = priv_app['PageLimit'] ? (priv_app['PageLimit'] >>> 0) : 0;
          priv_app['ReportLimit'] = priv_app['ReportLimit'] ? (priv_app['ReportLimit'] >>> 0) : 0;
      
          return privilegetemp[`user_${userid}`][appname];
        }
        return "";
      }
    }